import { render } from "./TradeInSpecialTest.vue?vue&type=template&id=98b7be7a"
import script from "./TradeInSpecialTest.vue?vue&type=script&lang=js"
export * from "./TradeInSpecialTest.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__